import { defineStore } from 'pinia';

export const useTemporaryUploadStore = defineStore('upload', {
	state: () => ({
		temporaryUpload: {} as Record<number, FileList>,
	}),

	getters: {},

	actions: {
		resetTempUpload() {
			this.temporaryUpload = {} as Record<number, FileList>;
		},
	},
});
